import { render, staticRenderFns } from "./billingDetails.vue?vue&type=template&id=f5d01098"
import script from "./billingDetails.vue?vue&type=script&lang=js"
export * from "./billingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports